import { render } from "./wxCollecting.vue?vue&type=template&id=47e602ac&scoped=true"
import script from "./wxCollecting.vue?vue&type=script&lang=js"
export * from "./wxCollecting.vue?vue&type=script&lang=js"

import "./wxCollecting.vue?vue&type=style&index=0&id=47e602ac&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e602ac"]])

export default __exports__